import React, { useEffect, useRef, useState } from 'react';
import {
  Dimensions, StyleSheet, Text, TouchableOpacity, View,
} from 'react-native';
import { useFonts } from '@use-expo/font';
import AsyncStorage from '@react-native-community/async-storage';
import domtoimage from 'dom-to-image';
import {
  Android,
  Back_to_projects,
  Could_not_save_configuration, deliverables_category,
  development_category,
  keyboard_category,
  launch_category,
  log_out,
  no_str,
  No_user,
  ok_str,
  onboarding_category,
  Reminder_editing_someone_else,
  send_category, Send_form,
  services_category,
  Sorry_window_size,
  theme_category,
  want_return_to_projects,
  want_to_exit,
  yes_str,
} from '../utils/DictionaryManagementUtils';
import {
  font_Quicksand_Bold,
  font_Quicksand_Light,
  font_Quicksand_Medium,
  font_Quicksand_Regular,
  font_Quicksand_SemiBold,
  font_rubik_Bold,
  font_rubik_Medium,
  font_rubik_Regular,
  font_SF_Bold,
  font_SF_Medium,
  font_SF_Regular,
} from '../utils/FontsManagementUtils';
import MyAskQuestionPopup from '../components/MyAskQuestionPopup';
import MyMessagePopup from '../components/MyMessagePopup';
import {
  cleanJsonToPublish, getDateFormat, getUserVersion, loadWebFonts, LocStr,
} from '../utils/Utils';

import { getJSONConfig } from '../defaultConfigurations/MainConfigurations';
import { arrangeScreenForSlideshow, arrangeScreenInJson } from './ScreensOrdering';

import SimulatorViewer from './SimulatorViewer';
import ControlPanelViewer from './ControlPanelViewer';
import TopBar from './TopBar';
import SideMenuBar from './SideMenuBar';
import { DEVELOPMENT_MODE } from '../utils/ExternalKeys';
import { expo } from '../../app.json';
import DatabaseHandler from '../ExportConfiguration/ExportFileManger/DatabaseHandler';
import DownloaderHandler from '../ExportConfiguration/ExportFileManger/DownloaderHandler';
import ServerGate from './ServerGate';
import mergeTwoJSONs from '../defaultConfigurations/MergeConfigurations';

const window = Dimensions.get('window');
const screen = Dimensions.get('screen');

export default function MainScreen({ navigation }) {
  // ============= Parameters ====================
  const token = navigation.state.params === undefined ? '' : navigation.state.params.token;
  const loggedInUserId = navigation.state.params === undefined
    ? ''
    : navigation.state.params.loggedInUserId;
  const loggedInUserItem = navigation.state.params && navigation.state.params.loggedInUserItem;
  const selectedUser = navigation.state.params === undefined
    ? null
    : navigation.state.params.userItem;
  const onRefreshScreen = navigation.state.params === undefined
    ? null
    : navigation.state.params.onRefreshScreen;

  const cameFromAdmin = onRefreshScreen !== null && onRefreshScreen !== undefined;

  global.token = token;

  // ######################################################################

  // ============= variables ====================
  const prefKeyLanguage = 'prefKeyLanguageH6';
  const prefKeyDeviceType = 'prefKeyDeviceType';

  //----------------------------------------------------------------------
  const [language, setLanguage] = useState('english');

  const [selectedScreen, setSelectedScreen] = useState(0);

  const [deviceType, setDeviceType] = useState({
    isShowingMenu: false,
    selectedPlatform: 'iOS',
  });

  const ref_scroll_view = useRef();

  const arrSnapshotRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  //----------------------------------------------------------------------

  const [isSlideshowOn, setSlideshowOn] = useState(false);
  const [slideshowState, setSlideshowState] = useState({
    totImages: 0,
    idxImages: 0,
  });
  const slideshowRefs = {
    arr: [...Array(200).keys()].map(() => useRef(null)),
    index: 0,
  };

  let htmlImagesArray = '';

  const [slideshowJSON, setSlideshowJSON] = useState({});

  // ######################################################################

  const [, setDimensions] = useState({ window, screen });

  const [messagePopupState, setMessagePopupState] = useState({
    isMessageVisible: false,
    title: '',
  });

  const [questionPopupState, setQuestionPopupState] = useState({
    isQuestionVisible: false,
    questionId: '',
    title: '',
  });

  const [popupChangeOrderScreen, setPopupChangeOrderScreen] = useState('');

  const [animating, setAnimating] = useState(0);

  const [mainMenuState, setMainMenuState] = useState({ isMenuOpen: false });

  const [hasChangesState, setHasChangesState] = useState(false);

  const [iMsgSimulatorState, setiMsgSimulatorState] = useState(false);

  const [bothSimulatorState, setBothSimulatorState] = useState(false);

  const screenWidth = Dimensions.get('window').width;
  const screenHeight = Dimensions.get('window').height;

  useEffect(() => {
    loadTables();

    loadOtherPrefs();

    Dimensions.addEventListener('change', onChange);
    return () => {
      Dimensions.removeEventListener('change', onChange);
    };
  }, []);

  const onChange = ({ wind, scrn }) => {
    setDimensions({ wind, scrn });
  };

  //----------------------------------------------------------------------

  const [fontsLoaded] = useFonts({
    'Rubik-Regular': font_rubik_Regular,
    'Rubik-Medium': font_rubik_Medium,
    'Rubik-Bold': font_rubik_Bold,
    'Quicksand-Bold': font_Quicksand_Bold,
    'Quicksand-Light': font_Quicksand_Light,
    'Quicksand-Medium': font_Quicksand_Medium,
    'Quicksand-Regular': font_Quicksand_Regular,
    'Quicksand-SemiBold': font_Quicksand_SemiBold,
    'SF-Regular': font_SF_Regular,
    'SF-Medium': font_SF_Medium,
    'SF-Bold': font_SF_Bold,
  });

  //-----------------------------------------------------------------------------

  const [globJSON, setGlobJSON] = useState({});

  const serverGate = new ServerGate();
  const databaseHandler = new DatabaseHandler(serverGate, selectedUser, arrSnapshotRefs);
  const downloaderHandler = new DownloaderHandler(arrSnapshotRefs);

  const styles = StyleSheet.create({
    container: {
      backgroundColor: 'white',
    },

    loadingTitle: {
      textAlign: 'center',
      fontFamily: 'Quicksand-Medium',
      fontSize: 20,
      color: '#001a2f',
    },

    bodyStyle: {
      flex: 1,
      flexDirection: 'row',
    },
  });

  const loadTables = async () => {
    try {
      let item = await AsyncStorage.getItem(prefKeyLanguage);
      if (item === null) {
        item = 'english';
      }
      let defaultJSON = getJSONConfig();
      if (
        selectedUser === null
                || selectedUser.userConfigs === null
                || selectedUser.userConfigs === undefined
                || selectedUser.userConfigs.length === 0
      ) {
        if (selectedUser !== null) {
          prepareInitUser(defaultJSON);
        }
      } else {
        const in_config = JSON.parse(JSON.stringify(selectedUser.userConfigs[0]));

        defaultJSON = mergeTwoJSONs(defaultJSON, in_config);
        prepareInitUser(defaultJSON);
        setAnimating(1);
        serverGate.initializeMainConfigurations(defaultJSON).then(() => {
          setAnimating(2);
          setTimeout(() => {
            setAnimating(0);
          }, 2000);
        });
      }
      arrangeScreenInJson(defaultJSON);
      setGlobJSON(defaultJSON);
      await loadWebFonts(defaultJSON);
      setLanguage(item);
    } catch (errMsg) {
      console.log(errMsg);
    }
  };

  //--------------------------------------------------------------------

  const loadOtherPrefs = async () => {
    try {
      let item = await AsyncStorage.getItem(prefKeyDeviceType);
      if (item === null || item === 'iMessage') {
        item = 'iOS';
      }
      setDeviceType({ selectedPlatform: item, isShowingMenu: false });
    } catch (errMsg) {
      console.log(errMsg);
    }
  };

  const handlePlatformSelected = (newVal) => {
    setDeviceType({ selectedPlatform: newVal, isShowingMenu: false });
    saveOtherPrefs(newVal);
  };

  const saveOtherPrefs = async (newVal) => {
    try {
      await AsyncStorage.setItem(prefKeyDeviceType, newVal);
    } catch (errMsg) {
      console.log(errMsg);
    }
  };

  useEffect(() => {
    handleiMsgSimulatorChange();
    handleBothSimulatorChange();
  }, [selectedScreen]);

  const handleiMsgSimulatorChange = () => {
    if (globJSON && globJSON.screens && globJSON.screens[selectedScreen]) {
      const currentScreenName = globJSON.screens[selectedScreen].screen_name;
      if (
        globJSON.configurations.deliverables.deliverables.iMsg_enabled
                && currentScreenName === services_category
      ) {
        setiMsgSimulatorState(true);
      } else {
        if (deviceType.selectedPlatform === 'iMessage') {
          setDeviceType({ ...deviceType, selectedPlatform: 'iOS' });
        }
        setiMsgSimulatorState(false);
      }
    }
  };

  const handleBothSimulatorChange = () => {
    if (globJSON && globJSON.screens && globJSON.screens[selectedScreen]) {
      if (globJSON.screens[selectedScreen].screen_name === Send_form
      ) {
        setBothSimulatorState(true);
      } else {
        if (deviceType.selectedPlatform === 'Both') {
          setDeviceType({ ...deviceType, selectedPlatform: 'Android' });
        }
        setBothSimulatorState(false);
      }
    }
  };

  const onSavePressed = async () => {
    if (selectedUser) {
      if (loggedInUserId === selectedUser.userId) {
        await doSaveChanges(); // save pressed
      } else {
        const txt = LocStr(Reminder_editing_someone_else, language);
        setQuestionPopupState({
          isQuestionVisible: true,
          questionId: 'save',
          title: txt,
        });
      }
    } else {
      const txt = LocStr(No_user, language);
      setMessagePopupState({ isMessageVisible: true, title: txt });
    }
  };

  const onLogoutAnsweredYes = (allTheWay) => {
    if (onRefreshScreen !== null && onRefreshScreen !== undefined) {
      onRefreshScreen();
    }

    navigation.pop();
    if (allTheWay) {
      navigation.pop();
    }
  };

  const onQuestionAnsweredYes = async (questionId) => {
    setQuestionPopupState({
      isQuestionVisible: false,
      questionId: '',
      title: '',
    });

    switch (questionId) {
      // these are actions from the main menu:
      case 'back_to_projects':
        onLogoutAnsweredYes(false);
        break;
      case 'logout':
        onLogoutAnsweredYes(true);
        break;

        // these are actions from the last (Send) screen
      case 'save':
        await doSaveChanges();
        break;
      default:
    }
  };

  const onBackToProjectsPressed = () => {
    const txt = LocStr(want_return_to_projects, language);
    setQuestionPopupState({
      isQuestionVisible: true,
      questionId: 'back_to_projects',
      title: txt,
    });
  };

  const onLogoutPressed = () => {
    const txt = LocStr(want_to_exit, language);
    setQuestionPopupState({
      isQuestionVisible: true,
      questionId: 'logout',
      title: txt,
    });
  };

  const onHomePressed = () => {
    stopSlideshow();

    const wantedScreen = 0;
    if (wantedScreen !== -1) {
      const wantedIndex = globJSON.screens[wantedScreen].screen_index;
      ref_scroll_view.current.scrollTo({
        x: 560 * wantedIndex,
        y: 0,
        animated: false,
      });
      myUpdateSelectedScreen(wantedScreen);
    }
  };

  const calcSelectedTab = () => {
    switch (globJSON.screens[selectedScreen].category) {
      case theme_category:
        return 0;
      case services_category:
        return 1;
      case launch_category:
        return 2;
      case deliverables_category:
        return 3;
      case onboarding_category:
        return 4;
      case keyboard_category:
        return 5;
      case send_category:
        return 6;
      case development_category:
        return 7;
      default:
        return 0;
    }
  };

  const handlePressOnTab = (wantedTab) => {
    if (popupChangeOrderScreen !== '') {
      setPopupChangeOrderScreen('');
    }

    stopSlideshow();

    let wantedCategory = '';
    switch (wantedTab) {
      case 0:
        wantedCategory = theme_category;
        break;
      case 1:
        wantedCategory = services_category;
        break;
      case 2:
        wantedCategory = launch_category;
        break;
      case 3:
        wantedCategory = deliverables_category;
        break;
      case 4:
        wantedCategory = onboarding_category;
        break;
      case 5:
        wantedCategory = keyboard_category;
        break;
      case 6:
        wantedCategory = send_category;
        break;
      case 7:
        wantedCategory = development_category;
        break;
      default:
        break;
    }

    const wantedScreen = globJSON.screens.findIndex(
      (item) => item.category === wantedCategory,
    );
    if (wantedScreen !== -1) {
      const wantedIndex = globJSON.screens[wantedScreen].screen_index;
      ref_scroll_view.current.scrollTo({
        x: 560 * wantedIndex,
        y: 0,
        animated: false,
      });
      myUpdateSelectedScreen(wantedScreen);
    }
  };

  const myUpdateSelectedScreen = (newVal) => {
    setSelectedScreen(newVal);
  };

  const handleExportingRequest = async (exportOptions) => {
    setAnimating(1);
    if (exportOptions.forDownload) {
      await downloaderHandler.handleExporting(exportOptions, globJSON.configurations);
    } else {
      await doSaveChanges();
      await databaseHandler.handleExporting(exportOptions, globJSON.configurations);
    }
    setAnimating(2);
    setTimeout(() => {
      setAnimating(0);
    }, 2000);
  };

  const doSaveChanges = async () => {
    setAnimating(1);
    prepareUser();
    await serverGate.updateUserInServer(token,
      selectedUser,
      () => setHasChangesState(false),
      (errMsg) => {
        setMessagePopupState({
          isMessageVisible: true,
          title: Could_not_save_configuration + (errMsg || 'errMsg'),
        });
        console.log(errMsg);
      });
    setAnimating(2);
    setTimeout(() => {
      setAnimating(0);
    }, 2000);
  };

  const prepareUser = () => {
    globJSON.updated_by = loggedInUserItem.userEmail;
    globJSON.last_updated_at = getDateFormat();
    selectedUser.userConfigs[0] = cleanJsonToPublish(globJSON);
  };

  const prepareInitUser = (defaultJSON) => {
    defaultJSON.web_tool_version = expo.version;
    defaultJSON.bank_name = selectedUser.userInstitute;
    defaultJSON.configurations.general.bank_name = selectedUser.userInstitute;
    defaultJSON.user_name = selectedUser.userUsername;
    defaultJSON.full_name = selectedUser.userFullname;
    defaultJSON.userType = selectedUser.userType;
  };

  // ######################################################################
  // ###   C o n t r o l   P a n e l   a r e a
  // ######################################################################
  const onConfigChanged = (changeRequiresSaving = true) => {
    if (changeRequiresSaving) {
      setHasChangesState(true);
    }
    setGlobJSON({ ...globJSON });
  };

  // ######################################################################
  // ###   S i m u l a t i o n   a r e a
  // ######################################################################

  const showPlatformSelector = () => true;

  const showSlideshowButton = (index) => {
    const name = globJSON.screens[index].screen_name;
    return name === 'send_form';
  };

  const snapSlideshowImage = (idx, tot) => {
    domtoimage.toPng(slideshowRefs.arr[idx].current).then((dataUrl) => {
      setSlideshowState({
        totImages: slideshowRefs.index,
        idxImages: idx + 1,
      });

      if (idx < tot - 1) {
        htmlImagesArray = `${htmlImagesArray}'${dataUrl}',\n`;
        snapSlideshowImage(idx + 1, tot);
      } else {
        htmlImagesArray = `${htmlImagesArray}'${dataUrl}'`;

        setAnimating(0);

        const isAnd = deviceType.selectedPlatform === Android;
        const imageWidthString = '240px';
        const imageHeightString = isAnd ? '427px' : '520px';
        const filenameSuffix = isAnd ? 'and' : 'ios';

        const stubHtml = require('../../assets/tables/slideshow_stub.html');
        const { bank_name } = globJSON.configurations.general;
        const outHtml = stubHtml
          .replace('PUT_IMAGES_HERE', htmlImagesArray)
          .replace('PUT_BANK_NAME_HERE', bank_name)
          .replace('PUT_IMAGE_WIDTH_HERE', imageWidthString)
          .replace('PUT_IMAGE_HEIGHT_HERE', imageHeightString);

        downloaderHandler.exportFile(outHtml, `${bank_name}_${filenameSuffix}.html`);
        setSlideshowState({
          ...slideshowState,
          idxImages: 0,
        });
        setSlideshowOn(false);
      }
    });
  };

  const downloadSlideshow = () => {
    if (isSlideshowOn) {
      htmlImagesArray = '';
      const tot = slideshowRefs.index;
      if (tot > 0) {
        setAnimating(1);
        snapSlideshowImage(0, tot);
      }
    }
  };

  //----------------------------------------------------------------------

  const startSlideshow = () => {
    const slideshowJSONNew = JSON.parse(JSON.stringify(globJSON));
    setSlideshowJSON(slideshowJSONNew);

    arrangeScreenForSlideshow(slideshowJSONNew);

    slideshowRefs.index = 0;

    setSlideshowOn(true);
  };

  const stopSlideshow = () => {
    if (isSlideshowOn) {
      slideshowRefs.index = 0;
      setSlideshowOn(false);
    }
  };
    // ============= render ====================

  if (screenWidth < 900 && !DEVELOPMENT_MODE) {
    return (
      <View style={styles.container}>
        <View
          style={{
            height: screenHeight,
            width: screenWidth,
            justifyContent: 'center',
          }}
        >
          <Text style={styles.loadingTitle}>
            {LocStr(Sorry_window_size, language)}
          </Text>
        </View>
      </View>
    );
  }

  if (
    !fontsLoaded
        || globJSON.screens === null
        || globJSON.screens === undefined
  ) {
    return <View style={styles.container} />;
  }
  return (
    <View style={styles.container}>
      <TopBar
        onHomePressed={onHomePressed}
        screenWidth={screenWidth}
        mainMenuState={mainMenuState}
        setMainMenuState={setMainMenuState}
        userItem={selectedUser}
        animating={animating}
        hasChangesState={hasChangesState}
        language={language}
        onSavePressed={onSavePressed}
      />
      {/* -----   Body (ControlPanel & Simulator & SideMenu)   -------------------------------------*/}
      <View style={styles.bodyStyle}>
        <SimulatorViewer
          globJSON={globJSON}
          slideshowJSON={slideshowJSON}
          selectedScreen={selectedScreen}
          screenWidth={screenWidth}
          screenHeight={screenHeight}
          deviceType={deviceType}
          setDeviceType={setDeviceType}
          onConfigChanged={onConfigChanged}
          iMsgSimulatorState={iMsgSimulatorState}
          bothSimulatorState={bothSimulatorState}
          handlePlatformSelected={handlePlatformSelected}
          language={language}
          arrSnapshotRefs={arrSnapshotRefs}
          slideshowState={slideshowState}
          isSlideshowOn={isSlideshowOn}
          showPlatformSelector={showPlatformSelector}
          showSlideshowButton={showSlideshowButton}
          slideshowRefs={slideshowRefs}
          stopSlideshow={stopSlideshow}
          startSlideshow={startSlideshow}
          downloadSlideshow={downloadSlideshow}
        />
        <ControlPanelViewer
          globJSON={globJSON}
          selectedUser={selectedUser}
          loggedInUserItem={loggedInUserItem}
          language={language}
          selectedScreen={selectedScreen}
          ref_scroll_view={ref_scroll_view}
          onConfigChanged={onConfigChanged}
          deviceType={deviceType}
          startExportingAllFiles={handleExportingRequest}
          myUpdateSelectedScreen={myUpdateSelectedScreen}
          screenHeight={screenHeight}
        />

        <SideMenuBar
          handlePressOnTab={handlePressOnTab}
          calcSelectedTab={calcSelectedTab}
          language={language}
        />
      </View>

      {/* -----   P o p u p s   ----------------------------------------------*/}

      {mainMenuState.isMenuOpen ? (
        <TouchableOpacity
          style={{
            width: screenWidth,
            height: screenHeight,
            marginTop: 0,
            position: 'absolute',
            backgroundColor: 'rgba(0,0,0,0.0)',
          }}
          activeOpacity={1}
          onPress={() => {
            setMainMenuState({ isMenuOpen: false });
          }}
        >
          <View
            style={{
              width: 314,
              height: cameFromAdmin ? 92 + 46 + 46 : 92 + 46,
              marginLeft: screenWidth - 314,
              marginTop: 60,
              position: 'absolute',
              backgroundColor: '#fff',
              borderColor: '#cbd5e0',
              borderRadius: 4,
              borderWidth: 1,
              shadowColor: '#000',
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.22,
              shadowRadius: 12,
            }}
          >
            <View
              style={{ width: 314, height: 92, backgroundColor: '#edf2f7' }}
            >
              <Text
                style={{
                  marginLeft: 30,
                  marginTop: 22,
                  width: 254,
                  fontFamily: 'Rubik-Regular',
                  fontSize: 16,
                  textAlign: 'left',
                  color: '#001a2f',
                }}
              >
                {selectedUser.userFullname}
              </Text>
              <Text
                style={{
                  marginLeft: 30,
                  marginTop: 8,
                  width: 254,
                  fontFamily: 'Rubik-Regular',
                  fontSize: 16,
                  textAlign: 'left',
                  color: '#001a2f',
                }}
              >
                {loggedInUserItem.userEmail}
              </Text>
            </View>
            {cameFromAdmin ? (
              <TouchableOpacity
                style={{
                  width: 314,
                  height: 46,
                  marginTop: 0,
                  justifyContent: 'center',
                }}
                onPress={() => {
                  setMainMenuState({ isMenuOpen: false });
                  onBackToProjectsPressed();
                }}
              >
                <Text
                  style={{
                    marginLeft: 30,
                    width: 254,
                    fontFamily: 'Rubik-Regular',
                    fontSize: 16,
                    textAlign: 'left',
                    color: '#001a2f',
                  }}
                >
                  {LocStr(Back_to_projects, language)}
                </Text>
              </TouchableOpacity>
            ) : null}

            <TouchableOpacity
              style={{
                width: 314,
                height: 46,
                marginTop: 0,
                justifyContent: 'center',
              }}
              onPress={() => {
                setMainMenuState({ isMenuOpen: false });
                onLogoutPressed();
              }}
            >
              <Text
                style={{
                  marginLeft: 30,
                  width: 254,
                  fontFamily: 'Rubik-Regular',
                  fontSize: 16,
                  textAlign: 'left',
                  color: '#001a2f',
                }}
              >
                {LocStr(log_out, language)}
              </Text>
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
      ) : null}

      {messagePopupState.isMessageVisible && (
        <View style={{
          width: screenWidth,
          height: screenHeight,
          backgroundColor: 'rgba(52, 52, 52, 0.8)',
          position: 'absolute',
          padding: '25%',
        }}
        >
          <MyMessagePopup
            parentWidth={screenWidth}
            onOkPressed={() => setMessagePopupState({ isMessageVisible: false, title: '' })}
            okTitle={LocStr(ok_str, language)}
            message={messagePopupState.title}
            language={language}
          />
        </View>
      )}

      {questionPopupState.isQuestionVisible ? (
        <MyAskQuestionPopup
          parentWidth={screenWidth}
          onYesPressed={(questionId) => {
            onQuestionAnsweredYes(questionId);
          }}
          onNoPressed={() => setQuestionPopupState({
            isQuestionVisible: false,
            questionId: '',
            title: '',
          })}
          yesTitle={LocStr(yes_str, language)}
          noTitle={LocStr(no_str, language)}
          question={questionPopupState.title}
          questionId={questionPopupState.questionId}
          language={language}
        />
      ) : null}
    </View>
  );
}

// ============= styles ====================

MainScreen.navigationOptions = {
  headerShown: false,
};
